// Single source of truth for the localStorage key shape. Versioned so future
// contract-breaking schema changes can bump to v2 without colliding with old
// entries.

const STORAGE_KEY_PREFIX = 'postscript:messageDetailsOverride:v1:';

export const messageDetailsStorageKey = (shopId: number): string =>
  `${STORAGE_KEY_PREFIX}${shopId}`;

// Custom event channel used to notify same-tab subscribers when the override
// changes. The browser's native `storage` event only fires for *other* tabs.
export const MESSAGE_DETAILS_OVERRIDE_EVENT =
  'postscript:messageDetailsOverride:change';

export const FORCE_OVERRIDE_PARAM = 'messageDetailsForceOverride';
